import { createRouter, createWebHistory } from "vue-router";
import Layout from "@/views/layout.vue";
import { AuthRouterClass } from "./authRouter";
import { store } from "@/store";
import { createOidcService } from "@/utils/oidcServer";

const routes: Array<any> = [
  {
    path: "/",
    redirect: "/current/exams",
  },
  {
    path: "/upgrade",
    name: "upgrade",
    meta: { needLogin: false, name: "系统维护中" },
    component: () => import("@/views/upgrade.vue"),
  },
  {
    path: "/exam",
    name: "exams",
    redirect: "/exam/list",
    title: "我的考试",
    icon: "LaptopOutlined",
    meta: { needLogin: true },
    component: Layout,
    children: [
      {
        path: "/exam/list",
        name: "examlist",
        title: "我的考试列表",
        meta: { name: "我的考试" },
        component: () => import("@/views/registeredExams/index.vue"),
      },
    ],
  },
  {
    path: "/news",
    name: "news",
    redirect: "/news/list",
    title: "消息通知",
    icon: "LaptopOutlined",
    meta: { needLogin: true },
    component: Layout,
    children: [
      {
        path: "/news/list",
        name: "newslist",
        title: "消息通知",
        meta: { name: "消息通知" },
        component: () => import("@/views/news/newsList.vue"),
      },
    ],
  },
  {
    path: "/userCenter",
    name: "userCenter",
    redirect: "/userCenter/personal",
    meta: { needLogin: true },
    component: Layout,
    children: [
      {
        path: "/userCenter/personal",
        name: "personalinformation",
        title: "个人信息",
        meta: { name: "个人信息" },
        component: () => import("@/views/information/personalinformation.vue"),
      },
      {
        path: "/authentication",
        name: "authentication",
        title: "实名信息",
        meta: { name: "实名信息" },
        component: () => import("@/views/authentication/index.vue"),
      },

      {
        path: "/PrintEntryForm",
        name: "PrintEntryForm",
        title: "打印报名表",
        meta: { name: "打印报名表" },
        component: () => import("@/views/information/PrintEntryForm.vue"),
      },
    ],
  },
  {
    path: "/info/auth",
    name: "authCallBack",
    meta: { needLogin: false, name: "政务网实名认证回调" },
    component: () => import("@/views/hunanGovernmentAuthCallback/index.vue"),
  },
  {
    path: "/current",
    name: "currentExams",
    redirect: "/current/exams",
    title: "当前考试",
    icon: "LaptopOutlined",
    component: Layout,
    children: [
      {
        path: "/current/exams",
        name: "examList",
        title: "当前考试",
        meta: { needLogin: false, name: "当前考试" },
        component: () => import("@/views/currentexam/examList.vue"),
      },
      {
        path: "/current/positions",
        name: "positionlist",
        title: "职位列表",
        meta: { needLogin: true, name: "职位列表" },
        component: () => import("@/views/currentexam/positionlist.vue"),
      },
    ],
  },

  {
    path: "/notice",
    name: "notice",
    redirect: "/notice/list",
    title: "公告",
    icon: "LaptopOutlined",
    meta: { needLogin: false },
    component: Layout,
    children: [
      {
        path: "/notice/list",
        name: "noticeList",
        title: "公告",
        meta: { name: "公告" },
        component: () => import("@/views/notice/list.vue"),
      },
      {
        path: "/notice/list/details",
        name: "noticeListDetails",
        title: "公告详情",
        meta: { name: "公告详情" },
        component: () => import("@/views/notice/details.vue"),
      },
    ],
  },
  {
    path: "/workFlowStep",
    name: "workFlowStep",
    redirect: "/workFlowStep/main",
    title: "报名流程",
    meta: { needLogin: true },
    component: Layout,
    children: [
      {
        path: "/workFlowStep/main",
        name: "workFlowMain",
        title: "报名流程",
        component: () => import("@/views/workFlow/main.vue"),
      },
      {
        path: "/workFlowStep/myExamDetail",
        name: "myExamDetail",
        title: "报名详情",
        component: () => import("@/views/workFlow/myExamDetail.vue"),
      },
      {
        path: "/workFlowStep/ApplyForRefund",
        name: "ApplyForRefund",
        title: "退费申请",
        component: () => import("@/views/workFlow/ApplyForRefund.vue"),
      },
    ],
  },

  {
    system: "ticket",
    path: "/ticketLogin",
    name: "ticketLogin",
    title: "打印准考证登录",
    show: false,
    meta: { needLogin: false, name: "ticketLogin", title: "打印准考证" },
    component: () => import("@/views/ticket/login.vue"),
  },

  {
    path: "/ticket",
    name: "ticket",
    redirect: "/Printadmissionticket",
    meta: { needLogin: false },
    component: Layout,
    children: [
      {
        path: "/Printadmissionticket",
        name: "Printadmissionticket",
        title: "打印准考证",
        meta: { name: "打印准考证" },
        component: () => import("@/views/information/Printadmissionticket.vue"),
      },
    ],
  },
  {
    system: "examinee",
    path: "/scoreQueryLogin",
    name: "scoreQueryLogin",
    title: "查询成绩登录",
    show: false,
    meta: { needLogin: false, name: "scoreQueryLogin", title: "查询成绩" },
    component: () => import("@/views/scoreQuery/login.vue"),
  },
  {
    path: "/scoreQueryDetail",
    name: "scoreQueryDetail",
    redirect: "/scoreQuery/index",
    title: "成绩查询详情",
    meta: { needLogin: false },
    component: Layout,
    children: [
      {
        path: "/scoreQuery/index",
        name: "scoreQueryDetailList",
        title: "成绩查询详情",
        component: () => import("@/views/scoreQuery/detailWeb.vue"),
      },
    ],
  },
  {
    path: "/mob/scoreQueryDetail",
    name: "mobScoreQueryDetail",
    title: "成绩查询详情-移动端",
    meta: { needLogin: false },
    component: () => import("@/views/scoreQuery/detailMob.vue"),
  },

  {
    path: "/registeredUser",
    redirect: "/register",
    meta: { needLogin: false },
    component: Layout,
    children: [
      {
        path: "/register",
        name: "register",
        title: "用户注册",
        component: () => import("@/views/register/index.vue"),
      },
      {
        path: "/resetPassword",
        name: "resetPassword",
        title: "忘记密码",
        component: () => import("@/views/resetPassword/resetPassword.vue"),
      },
    ],
  },

  {
    path: "/realName",
    redirect: "/",
    meta: { needLogin: true },
    component: Layout,
    children: [
      {
        path: "/changePhone",
        name: "changePhone",
        title: "换绑手机",
        component: () => import("@/views/changePhone/changePhone.vue"),
      },
      {
        path: "/modifyPassword",
        name: "modifyPassword",
        title: "修改密码",
        component: () => import("@/views/modifyPassword/modifyPassword.vue"),
      },
      {
        path: "/realNameAuthLevel",
        name: "realNameAuthLevel",
        title: "实名认证等级提升",
        component: () => import("@/views/realNameAuthLevel/index.vue"),
      },
      {
        path: "/realNamePhoto",
        name: "realNamePhoto",
        title: "实名照片",
        component: () => import("@/views/realNamePhoto/index.vue"),
      },
    ],
  },

  {
    path: "/login",
    name: "login",
    title: "用户登录",
    meta: { needLogin: false },
    component: () => import("@/views/loginByOidc/index.vue"),
  },
  {
    path: "/logout",
    name: "logout",
    title: "用户登出",
    meta: { needLogin: false },
    component: () => import("@/views/logout/index.vue"),
  },
  {
    path: "/privacyClause",
    name: "privacyClause",
    title: "用户服务条款",
    component: () => import("@/views/privacyClause/index.vue"),
  },
  {
    path: "/bindOpenId",
    name: "bindOpenId",
    title: "绑定公众号",
    show: false,
    component: () => import("@/views/bindOpenId/bindOpenId.vue"),
  },
  {
    path: "/ZF_DynaActionForm",
    name: "ZF_DynaActionForm",
    title: "动态表单",
    show: false,
    component: () => import("@/zf_components/ZF-form/demo-ZF_DynaActionForm.vue"),
  },
  {
    path: "/signinOidc",
    name: "signinOidc",
    title: "signinOidc登录",
    show: false,
    component: () => import("@/views/loginByOidc/oidc/signinOidc.vue"),
  },
  {
    path: "/refreshOidc",
    name: "refreshOidc",
    title: "refreshOidc刷新",
    show: false,
    component: () => import("@/views/loginByOidc/oidc/refreshOidc.vue"),
  },
  {
    path: "/logoutOidc",
    name: "logoutOidc",
    title: "logoutOidc登出",
    show: false,
    component: () => import("@/views/refresh.vue"),
  },
  {
    path: "/Refresh",
    name: "Refresh",
    title: "刷新",
    show: false,
    component: () => import("@/views/refresh.vue"),
  },
  {
    path: "/404",
    name: "404",
    title: "404",
    show: false,
    component: () => import("@/views/404.vue"),
  },
  // 未知页（动态路由地址）
  {
    path: "/:catchAll(.*)",
    name: "NotFound",
    component: () => import("@/views/404.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to, from, next) => {
  // console.log("路由权限", { to, from, isLogin: store.state.isLogin });
  next();
  // if (store.state.isLogin) {
  //   // 需要排除的实名照片认证路由列表
  //   const excludeRoutes = ["realNamePhoto", "modifyPassword", "changePhone"];
  //   // 强制跳转完善实名照片
  //   if (AuthRouterClass.needRealNamePhotoAuth && !excludeRoutes.includes(to.name as string)) {
  //     next({
  //       name: "realNamePhoto",
  //       query: to.query, // 保留原始查询参数
  //       hash: to.hash, // 保留原始 hash
  //     });
  //     return;
  //   }
  //   next();
  // } else if (to.meta.needLogin) {
  //   console.log("需要登录");
  //   // next({ name: "login" });
  //   if (from.fullPath === "/") {
  //     next({ path: "/" });
  //   } else {
  //     next({ name: "login" });
  //   }
  // } else {
  //   next();
  // }

  // if (to.meta.needLogin) {
  //   console.log("当前路由需要登录", to.path);
  //   // 创建OIDC服务
  //   const oidcService = createOidcService();
  //   oidcService
  //     .handleSigninSilent()
  //     .then((user) => {
  //       console.log("静默刷新成功", user);
  //       next();
  //     })
  //     .catch((error) => {
  //       console.log("静默刷新失败", error);
  //     });
  //     next();
  // } else {
  //   console.log("当前路由不需要登录", to.path);
  //   next();
  // }
});

router.afterEach((to, from) => {
  // console.log("afterEach", { to, from, isLogin: store.state.isLogin });
});

export default router;
